<template>
	<div id="modal" class="modal modal-org-compare" role="dialog">
		<button type="button" class="btn-close" @click="close" aria-label="Close modal" title="Close">
			×
		</button>

		<header class="modal-header">
			<h3 class="modal-header-title">Compare Organisations</h3>
			<p v-if="mobile_view" class="modal-header-subtitle">Find out how organisations ways of working compare.</p>
		</header>

		<section class="modal-body">
			<div class="table-wrap scrollable-blue" :class="{ 'mobile': mobile_view, 'desktop': !mobile_view }">

				<table class="compare-table" :data-cols="orgs.length + 1" v-if="org_data">
					<tr class="compare-table__row_top">
						<th v-if="!mobile_view" class="compare-table__main-heading">Find out how organisations ways of working
							compare.</th>
						<template v-for="(slug, r) in display_orgs" :key="`r1_${r}`">

							<template v-if="slug == false">
								<th>
									<block-auto-complete-org :comparing_ids="comparing_ids" :column="r"
										@select="doSelect"></block-auto-complete-org>
								</th>
							</template>
							<template v-else>
								<th class="compare-table__org-hero">
									<div class="logo-img" @click="doRemove(r)">
										<img :src="orgPropBySlug(slug, 'logo')" :alt="orgPropBySlug(slug, 'org-name')" />
										<div class="overlay">
											<svg-trash-can></svg-trash-can>
											<div>Remove</div>
										</div>
									</div>
									<div><a :href="`/organisation/${slug}`" v-html="orgPropBySlug(slug, 'org-name')"></a></div>
								</th>
							</template>
						</template>
					</tr>

					<template v-for="(section, section_label) in sections" :key="`sec_${section_label}_heading`">
						<tr class="compare-table__row-heading">
							<template v-if="mobile_view">
								<td colspan="2" class="section-heading">{{ section_label }}</td>
							</template>
							<template v-else>
								<td class="section-heading">{{ section_label }}</td>
								<template v-for="(slug, r) in display_orgs" :key="`r7_${r}`">
									<td :class="{ 'clear': (!slug) }"></td>
								</template>
							</template>
						</tr>

						<template v-for="(row, row_label) in section" :key="`row_${row_label}_heading`">
							<tr class="compare-table__row">
								<td v-if="!mobile_view">{{ row_label }} <block-tooltip v-if="row.tooltip" :data="row.tooltip"
										class="ml-2 translate-y-0.5"></block-tooltip></td>
								<template v-for="(slug, r) in display_orgs" :key="`r8_${r}`">
									<td><span v-if="mobile_view">{{ row_label }}<br /></span>{{ (!slug) ? '' :
										orgBenefitPropBySlug(slug, section_label, row_label) }}</td>
								</template>
							</tr>
						</template>

					</template>

					<tr class="compare-table__row_bottom">
						<td v-if="!mobile_view"></td>
						<template v-for="(slug, r) in display_orgs" :key="`r26_${r}`">
							<td></td>
						</template>
					</tr>
				</table>
			</div>

			<block-loader v-if="loading"></block-loader>
		</section>

	</div>
</template>

<script>
import ls from 'localstorage-slim';

export default {
	name: 'Organisation Compare',

	props: {
		payload: {
			type: [Object, String]
		},
	},

	data() {
		return {
			lsKey: 'escCompare',
			orgs: [
				false
			],
			org_data: false,
			mobile_view: false,
			sections: [],
			loading: false
		}
	},

	created() {
		console.log("payload", this.payload);

		if (this.payload.compare) {
			// Load via the URL
			console.log("Load compare via URL")
			this.orgs = this.payload.compare.split(",");
		} else {
			// Load via the Local Storage
			console.log("Load compare via LS")
			this.orgs = ls.get(this.lsKey);
		}

		// When the modal is opened it can receive an additional org to add to the list.
		if (this.payload.additional) {
			let slug = this.payload.additional;
			if (slug && slug !== '') {
				if (this.orgs.includes(slug)) {
					// Ignore
				} else {
					if (this.orgs.length > 5) {
						// Again Ignore
					} else {
						this.orgs.push(slug);
					}
				}
			}
		}


		if (this.orgs == null) {
			console.log("orgs was null");
			this.orgs = [false];
		} else {
			this.loadOrganisationCompareData();
		}
		window.addEventListener('resize', this.resizeHandler);
		this.resizeHandler();
	},

	beforeUnmount() {
		window.removeEventListener('resize', this.resizeHandler);
	},

	methods: {
		doSelect(col, org) {
			console.log({ org });
			if (org.slug && org.slug !== '') {
				this.orgs[col] = org.slug;
				this.loadOrganisationCompareData();
			}
		},
		doRemove(pos) {
			this.orgs.splice(pos, 1);
			this.loadOrganisationCompareData();
		},
		close() {
			this.$emit('close')
		},
		resizeHandler() {
			let mql = window.matchMedia('(max-width: 768px)');
			console.log("Mobile v2:", document.documentElement.clientWidth, mql.matches);
			this.mobile_view = mql.matches;
		},
		loadOrganisationCompareData() {
			console.log("Loading Org Compare Data");
			this.loading = true;
			this.$nextTick(() => {
				return this.$api.loadOrganisationCompareData({ 'orgs': this.orgs }).then(
					(response) => {
						if (response.data.status == 'success') {
							this.org_data = response.data.organisations;
							this.checkMissingData();
							this.determineSections();
						}
					}
				).catch((response) => {
					console.log("Could not load applications.", response);
				}).then(() => {
					this.loading = false;
				});
			});

		},
		checkMissingData() {
			let filtered = this.orgs.filter((org_id) => {
				return Object.keys(this.org_data).includes(org_id);
			})
			if (filtered.length !== this.orgs.length) {
				this.orgs = filtered;
			}
		},
		determineSections() {
			// Determine the top level sections.
			let tmpSections = {};
			Object.values(this.org_data).forEach((org) => {
				if (org['sections'] !== undefined) {
					org['sections'].forEach((sec) => {
						if (sec.section !== '') {
							if (tmpSections[sec.title] == undefined) {
								tmpSections[sec.title] = {};
							}

							sec.items.forEach((item) => {
								if (tmpSections[sec.title][item['row-label']] == undefined) {
									tmpSections[sec.title][item['row-label']] = { 'tooltip': null };
								}
							})
						}
					});
				}
			})

			this.sections = tmpSections;
			console.log("sections", this.sections);
		},
		orgPropBySlug(slug, key) {
			console.log("Find", this.org_data);
			if (this.org_data[slug] !== undefined) {
				console.log(this.org_data[slug]);
				if (this.org_data[slug]['basic'][key] !== undefined) {

					return this.org_data[slug]['basic'][key];
				}
			}
			return '';
		},
		orgBenefitPropBySlug(slug, section, row) {
			if (slug in this.org_data) {
				if ('sections' in this.org_data[slug]) {
					let found_section = this.org_data[slug]['sections'].find((benefit) => {
						return benefit.title == section;
					});
					if (found_section) {
						let found_row = found_section.items.find((item) => {
							return item['row-label'] == row;
						});
						if (found_row) {
							return found_row['short-text'];
						}
					}
				}
			}
			return '-';
		},
		updateURLParameter(url, param, paramVal) {
			var TheAnchor = null;
			var newAdditionalURL = "";
			var tempArray = url.split("?");
			var baseURL = tempArray[0];
			var additionalURL = tempArray[1];
			var temp = "";

			if (additionalURL) {
				var tmpAnchor = additionalURL.split("#");
				var TheParams = tmpAnchor[0];
				TheAnchor = tmpAnchor[1];
				if (TheAnchor)
					additionalURL = TheParams;

				tempArray = additionalURL.split("&");

				for (var i = 0; i < tempArray.length; i++) {
					if (tempArray[i].split('=')[0] != param) {
						newAdditionalURL += temp + tempArray[i];
						temp = "&";
					}
				}
			}
			else {
				var tmpAnchor = baseURL.split("#");
				var TheParams = tmpAnchor[0];
				TheAnchor = tmpAnchor[1];

				if (TheParams)
					baseURL = TheParams;
			}

			if (TheAnchor)
				paramVal += "#" + TheAnchor;

			var rows_txt = temp + "" + param + "=" + paramVal;
			return baseURL + "?" + newAdditionalURL + rows_txt;
		}
	},
	computed: {
		comparing_ids() {
			return this.orgs.map((org) => {
				if (org) {
					return org['org-main-id'];
				}
			})
		},
		display_orgs() {
			if (this.mobile_view) {
				return this.orgs.slice(0, 2); // Two columns only
			}
			return this.orgs;
		},
		clean_orgs() {
			// removes any false orgs, for use in the url
			return this.orgs.filter((org) => {
				return org !== false;
			})
		}
	},
	watch: {
		orgs: {
			deep: true,
			handler() {
				if (!this.orgs) {
					this.orgs = [false];
				}

				if (this.orgs.length < 5 && this.orgs[this.orgs.length - 1] !== false) {
					this.orgs.push(false);
				}

				ls.set(this.lsKey, this.orgs);

				window.history.replaceState('', '', this.updateURLParameter(window.location.href, "compare", this.clean_orgs.join(",")));
			}
		}
	}
};
</script>
